<payee-popup title="Hitelező szerkesztése">
  @if (initLoading()) {
    <mat-progress-spinner
      color="accent"
      mode="indeterminate"
      diameter="100"
    ></mat-progress-spinner>
  }
  @if (!initLoading()) {
    <form [formGroup]="formGroup">
      <!-- Client name -->
      <payee-form-field width="max">
        <span payee-label>Név</span>
        <input
          payee-input
          formControlName="name"
        />
      </payee-form-field>
      <!-- Tax Number -->
      <payee-form-field width="max">
        <span payee-label>Adószám</span>
        <input
          payee-input
          formControlName="tax_number"
        />
      </payee-form-field>
      <!-- Client type -->
      <payee-form-field width="max">
        <span payee-label>Hitelező típusa</span>
        <payee-autocomplete
          formControlName="party_type_id"
          [options]="partyTypeOptions"
          [displayWith]="partyTypeDisplayWith"
        ></payee-autocomplete>
        @if (party_type_id.dirty && party_type_id.invalid) {
          <ng-container payee-error>
            @if (party_type_id.hasError("required")) {
              <span>A mező kitöltése kötelező</span>
            }
            @if (party_type_id.hasError("backend")) {
              <span>
                {{ party_type_id.getError("backend") }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <!-- Client address -->
      <form [formGroup]="address">
        <h2>{{ name.value || "Hitelező" }} kézbesítési címe</h2>
        <!-- Country -->
        <payee-form-field width="max">
          <span payee-label>Ország</span>
          <payee-autocomplete
            formControlName="country"
            [options]="countryOptions"
            [displayWith]="countryDisplayWith"
          ></payee-autocomplete>
          @if (country.dirty && country.invalid) {
            <ng-container payee-error>
              @if (country.hasError("required")) {
                <span>A mező kitöltése kötelező</span>
              }
              @if (country.hasError("backend")) {
                <span>
                  {{ country.getError("backend") }}
                </span>
              }
            </ng-container>
          }
        </payee-form-field>
        <div
          class="flex"
          style="justify-content: space-between"
        >
          <!-- Postcode -->
          <payee-form-field style="--width: 192px">
            <span payee-label>Irányítószám</span>
            <input
              payee-input
              formControlName="postcode"
            />
            @if (postcode.dirty) {
              <ng-container payee-error>
                @if (postcode.hasError("required")) {
                  <span>A mező kitöltése kötelező</span>
                }
              </ng-container>
            }
          </payee-form-field>
          <!-- Settlement -->
          <payee-form-field style="--width: 192px">
            <span payee-label>Település</span>
            <input
              payee-input
              formControlName="settlement"
            />
            @if (settlement.dirty) {
              <ng-container payee-error>
                @if (settlement.hasError("required")) {
                  <span>A mező kitöltése kötelező</span>
                }
              </ng-container>
            }
          </payee-form-field>
        </div>
        <!-- Street -->
        <payee-form-field width="max">
          <span payee-label>Utca és házszám</span>
          <input
            payee-input
            formControlName="street"
          />
          @if (street.dirty) {
            <ng-container payee-error>
              @if (street.hasError("required")) {
                <span>A mező kitöltése kötelező</span>
              }
            </ng-container>
          }
        </payee-form-field>
      </form>
      <!-- Client bank account -->
      <form [formGroup]="bankAccount">
        <div class="flex vcenter bank-account-header">
          <h2>{{ name.value || "Hitelező" }} bankszámlája</h2>
          @if (!lock_bank_account.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              [isBorderButton]="true"
              (click)="openLockBankAccountDialog()"
            >
              <payee-icon name="pencil"></payee-icon>
            </button>
          }
          @if (lock_bank_account.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              [isBorderButton]="true"
              (click)="openUnlockBankAccountDialog()"
            >
              <payee-icon name="lock-grey"></payee-icon>
            </button>
          }
        </div>
        <payee-form-field width="max">
          <span payee-label>Számlaszám</span>
          <input
            payee-input
            formControlName="account_number"
          />
          @if (account_number.dirty && account_number.invalid) {
            <ng-container payee-error>
              @if (account_number.hasError("pattern")) {
                <span>Helytelen formátum!</span>
              }
              @if (account_number.hasError("backend")) {
                <span>
                  {{ account_number.getError("backend") }}
                </span>
              }
            </ng-container>
          }
        </payee-form-field>
        <payee-form-field width="max">
          <span payee-label>IBAN</span>
          <input
            payee-input
            formControlName="iban"
          />
          @if (iban.dirty && iban.invalid) {
            <ng-container payee-error>
              @if (iban.hasError("pattern")) {
                <span>Helytelen formátum!</span>
              }
              @if (iban.hasError("backend")) {
                <span>
                  {{ iban.getError("backend") }}
                </span>
              }
            </ng-container>
          }
        </payee-form-field>
        <payee-form-field width="max">
          <span payee-label>BIC</span>
          <input
            payee-input
            formControlName="bic"
          />
          @if (bic.dirty && bic.invalid) {
            <ng-container payee-error>
              @if (bic.hasError("backend")) {
                <span>
                  {{ bic.getError("backend") }}
                </span>
              }
            </ng-container>
          }
        </payee-form-field>
        <payee-form-field width="max">
          <span payee-label>Bank neve</span>
          <input
            payee-input
            formControlName="bank_name"
          />
          @if (bank_name.dirty && bank_name.invalid) {
            <ng-container payee-error>
              @if (bank_name.hasError("backend")) {
                <span>
                  {{ bank_name.getError("backend") }}
                </span>
              }
            </ng-container>
          }
        </payee-form-field>
        <payee-form-field width="max">
          <span payee-label>Kedvezményezett neve</span>
          <input
            payee-input
            formControlName="account_holder_name"
          />
          @if (account_holder_name.dirty && account_holder_name.invalid) {
            <ng-container payee-error>
              @if (account_holder_name.hasError("backend")) {
                <span>
                  {{ account_holder_name.getError("backend") }}
                </span>
              }
            </ng-container>
          }
        </payee-form-field>
      </form>
      <!-- Errors that didn't match any fields in the form -->
      @if (formGroup.dirty && formGroup.invalid) {
        <div
          color="alert-red"
          payee-error
        >
          @if (formGroup.hasError("backend")) {
            <span>
              {{ formGroup.getError("backend") }}
            </span>
          }
        </div>
      }
    </form>
  }
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="formGroup.invalid"
      (click)="submit()"
    >
      Mentés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      mat-dialog-close=""
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
